/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize GeneralSocialTSocialRisk View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './GeneralSocialTSocialRiskView';

export const mapStateToPropsGeneralSocialTSocialRisk = mapStateToProps;
export const mapDispatchToPropsGeneralSocialTSocialRisk = mapDispatchToProps;

export default connect(
  mapStateToPropsGeneralSocialTSocialRisk,
  mapDispatchToPropsGeneralSocialTSocialRisk
)(View);
